import { TableColumn } from "../table/TableColumn";

const ButtonConfigurationColumns : TableColumn[] = [
    {
        heading: "Button",
        accessor: "type",
        isNumeric: false,
        id: 0,
        active: true,
        translationKey: "button",
        isDefault: true,
    },
    {
        heading: "Button Text",
        accessor: "name",
        isNumeric: false,
        id: 1,
        // sortByName: "displayName",
        sortDirection: "asc",
        active: true,
        translationKey: "buttonText",
        isDefault: true,
    },
];

export default ButtonConfigurationColumns;
